export default "__VITE_ASSET__62fc3f0b__"